import React, { useEffect, useState } from "react";
import { useTabs } from "../hooks/useTabs";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Spin from "../ui/Spin";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import EnumField from "../ui/EnumField";
import { arrayToObject } from "../utils/Utils";

export default function POSChangeDiscounts(props) {

    const { controller = "", route = "", callback = () => { }, invoice = "", pos_id = "", employee = "", from_discount = 0, to_discount = 0, sort = ""  } = props;

    const [loading, setLoading] = useState(false);

    const defaults = [
        { key: "from_discount", value: "" }, // from_discount is the field's value 
        { key: "to_discount", value: 0 }, // to_discount is the customer's discount
        { key: "ignore_discount_rules", value: true },
        { key: "on_all", value: true }
    ];
    const { tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs } = useTabs(defaults, "from_discount");

    const changeDiscounts = (_key = "", _value = "") => {

        let _obj = arrayToObject(tabs);
        if(_obj.hasOwnProperty(_key)){
            _obj[_key] = _value; 
        }
        
        setLoading(true);

        const _params = {
            invoice: invoice,
            pos_id: pos_id,
            sort: sort,
            limit: 40,
            on_all: _obj.on_all,
            from_discount: parseInt(_obj.from_discount) || null,
            to_discount: parseInt(_obj.to_discount),
            clerk_code: employee,
            ignore_discount_rules: _obj.ignore_discount_rules,
        }

        pubCall("point_of_sale.setDiscountOnAllItems", _params, (_s, _r) => {
            if (_s) {
                showMessage("Discounts adjusted");
                callback(_r);
            } else {
                showError(_r);
            }
            setLoading(false);
        });
    }


    const statusus = {
        from_discount: "Discount to be change or blank (all)",
        to_discount: "",
        ignore_discount_rules: "[Y]es to ignore rules/limits",
        on_all: "<A>ll items or <F>rom this point on",
    };


    useEffect(() => {


        refs?.current?.[index]?.focus?.();
        refs?.current?.[index]?.select?.();
        

        const actions = [
            { key: KBD.ESCAPE, action: () => callback() },
            { key: KBD.ARROW_DOWN, action: () => next() },
            { key: KBD.ARROW_UP, action: () => prev() },
            { key: KBD.TAB, action : () => next()},
            { key: KBD.SHIFT_TAB, action : () => prev()}
        ]

        const cleanup = listen(
            controller,
            route,
            actions,
            false,
            [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE, KBD.PAGE_DOWN]
        );

        return cleanup;
    }, [index]);


    const yes_no = [
        { label: "Yes", value: true, key: KBD.Y },
        { label: "No", value: false, key: KBD.N }
    ];

    const all_from = [
        { label: "A", value: true, key: KBD.A },
        { label: "F", value: false, key: KBD.F }
    ];

   
    return (
        <div style={{ "width": "310px" }}>
            <Spin loading={loading}>
                <div className="shim" /><div className="shim" />
                <Space>
                    <Label width={250} >Change discounts from</Label>
                    <Input maxWidth={2} maxLength={2} width={35} {...editProps("from_discount")} onEnter={(e) => { update("from_discount", e); next(); }} onPageDown={(e) => changeDiscounts("from_discount", e)} chars={["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", ""]}></Input>
                </Space>
                <div className="shim" />
                <Space>
                    <Label width={250} >to</Label>
                    <Input maxWidth={2} maxLength={2} width={35} {...editProps("to_discount")} onEnter={(e) => { update("to_discount", e); next(); }} onPageDown={(e) => changeDiscounts("to_discount", e)} chars={["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", ""]}></Input>
                </Space>
                <div className="shim" />
                <Space>
                    <Label width={250} >Change regardless of discount rules?</Label>
                    <EnumField width={35} allow_empty={false} {...editProps("ignore_discount_rules")} onEnter={(e) => { update("ignore_discount_rules", e); next(); }} onPageDown={(e) => changeDiscounts("ignore_discount_rules", e)} options={yes_no} />
                </Space>
                <div className="shim" />
                <Space>
                    <Label width={250} >All items from this point on?</Label>
                    <EnumField width={35} allow_empty={false} {...editProps("on_all")} onPageDown={(e) => changeDiscounts("on_all", e)} options={all_from} />
                </Space>
                <div className="shim" /><div className="shim" />
            </Spin>
            <div className="shim" />
            <Status type="active"><InfoIcon />{statusus[index]}</Status>
        </div>
    )
}